import React from 'react'
import PlanWrapper from '../../Common/PlanWrapper'

const RehabilitationPlansWrapper = () => (
  <PlanWrapper planType='rehabilitation' planLabel='Rehabilitation Plans' isMonitoring={false} />
)

export default RehabilitationPlansWrapper
